import Button from "../Button";
import { LeftArrowIcon, RightArrowIcon } from "../../utils/icon.utils";
import usePaginationParams from "../../hooks/usePaginationParams";

export default function TablePagination({ totalPage }) {
  const { currentPage, pageSize, setPage, nextPage, prevPage, setSize } =
    usePaginationParams();

  const pages = generatePagination(currentPage, totalPage);

  return totalPage > 0 ? (
    <ul className="list-unstyled d-flex flex-wrap gap-1 align-items-center">

      {/* Prev */}
      <li>
        <Button
          onClick={prevPage}
          disabled={currentPage === 1}
          icon={LeftArrowIcon}
        />
      </li>

      {/* Pages */}
      {pages.map((p, idx) => (
        <li key={idx}>
          {p === "..." ? (
            <span className="px-2">...</span>
          ) : (
            <Button
              name={p}
              isActive={p === currentPage}
              onClick={() => setPage(p)}
            />
          )}
        </li>
      ))}

      {/* Next */}
      <li>
        <Button
          onClick={nextPage}
          disabled={currentPage === totalPage}
          icon={RightArrowIcon}
        />
      </li>

      {/* Page Size */}
      <li className="ms-2">
        <select
          className="form-select form-select-sm"
          style={{ width: "80px" }}
          value={pageSize}
          onChange={(e) => setSize(Number(e.target.value))}
        >
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
        </select>
      </li>
    </ul>
  ) : null;
}


const generatePagination = (current, total) => {
  const pages = [];

  const firstPages = [1, 2, 3, 4, 5].filter(p => p <= total);
  const lastPages = [
    total - 4, total - 3, total - 2, total - 1, total
  ].filter(p => p >= 1);

  const middlePages = [
    current - 1,
    current,
    current + 1
  ].filter(p => p > 5 && p < total - 4);

  // add first 5 pages
  pages.push(...firstPages);

  // left ellipsis
  if (middlePages.length && middlePages[0] > 6) {
    pages.push("...");
  }

  // add middle pages
  pages.push(...middlePages);

  // right ellipsis
  if (middlePages.length && middlePages[middlePages.length - 1] < total - 5) {
    pages.push("...");
  }

  // add last 5 pages
  pages.push(...lastPages);

  // remove duplicates
  return [...new Set(pages)];
};
